import { Animation } from './Animation'
import analyzingData from './data/analyzing.json'
import { LottieProps } from 'react-lottie-player'

const Analyzing = (props: LottieProps) => <Animation {...props} animationData={analyzingData} />

export default Analyzing
